import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable,take, throwError } from 'rxjs';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ConfigService } from 'src/services/json-config.service';
import { IApiClientAccountOut, IApiInvestmentProfileOut } from 'src/models/user.model';
import { AuthDataService } from '../auth-data.service';
import { getAppHeaders } from 'src/util/functions-angular';
import { DeviceService } from 'src/services/device.service';

@Injectable({ providedIn: 'root' })
export class UserRestApiService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private authDataService = inject(AuthDataService);
  private deviceService = inject(DeviceService);

  private get appHeaders() {
    return getAppHeaders({
      accept: 'application/json',
      accessToken: this.authDataService.accessToken(),
      isNativeApp: this.deviceService.isNativePlatform,
    })
  }

    // GET /api/v1/client/current
  public getUserDetail(): Observable<IApiClientAccountOut> {
    return this.http
      .get<IApiClientAccountOut>(
        `${this.configService.getConfig(EnvironmentKeys.apiUrl)}v1/client/current`,
        {
          headers: this.appHeaders,
        },
      ).pipe(
        take(1),
        catchError(this.handleError.bind(this)),
      );
  }

  // GET /api/v1/client/{clientId}/investment-profile
  public getInvestmentProfile(clientId: number): Observable<IApiInvestmentProfileOut> {
    return this.http
      .get<IApiInvestmentProfileOut>(
        `${this.configService.getConfig(EnvironmentKeys.apiUrl)}v1/client/${clientId}/investment-profile`,
        {
          headers: this.appHeaders,
        },
      ).pipe(
        take(1),
        catchError(this.handleError.bind(this)),
      );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error);
  }
}
